"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchObjects = exports.createSearchObjects = exports.getObjectsByIds = exports.createGetObjectsByIds = exports.OBJECT_SEARCH_CONFIGS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _ReferenceObjectTypes = _interopRequireDefault(require("reference-resolvers/constants/ReferenceObjectTypes"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _immutable = require("immutable");

var _formatReferences = require("reference-resolvers/lib/formatReferences");

var _compose = _interopRequireDefault(require("transmute/compose"));

var _curry = _interopRequireDefault(require("transmute/curry"));

var _get = _interopRequireDefault(require("transmute/get"));

var _getIn = _interopRequireDefault(require("transmute/getIn"));

var _hasIn = _interopRequireDefault(require("transmute/hasIn"));

var _updateIn = _interopRequireDefault(require("transmute/updateIn"));

var _formatContacts = require("reference-resolvers/formatters/formatContacts");

var _OBJECT_SEARCH_CONFIG;

var SEARCH_API = 'contacts/search/v1/search/';
var addSortBy = (0, _curry.default)(function (property, searchQuery) {
  searchQuery = searchQuery.toJS();

  if (searchQuery.sorts == null || searchQuery.sorts.length === 0) {
    return (0, _extends2.default)({}, searchQuery, {
      sorts: [{
        property: property,
        order: 'ASC'
      }]
    });
  }

  return searchQuery;
});
var withIdField = (0, _curry.default)(function (idField, ids) {
  return {
    count: ids.length,
    filterGroups: [{
      filters: [{
        property: idField,
        operator: 'IN',
        values: ids
      }]
    }]
  };
});
var formatResults = (0, _curry.default)(function (resultsKey, getters, response) {
  var offset = response.offset,
      count = response.total,
      results = response[resultsKey];
  var hasMore = response.hasOwnProperty('has-more') ? response['has-more'] : response.hasMore;
  return (0, _immutable.Map)({
    hasMore: hasMore,
    offset: offset + results.length,
    count: count,
    results: (0, _formatReferences.formatToReferencesList)(getters, results)
  });
});

var subtractResultsFromOffset = function subtractResultsFromOffset(response) {
  return (0, _extends2.default)({}, response, {
    offset: response.offset - response.results.length
  });
};

var findNamedProperty = (0, _curry.default)(function (propertyName, properties) {
  return properties.find(function (p) {
    return (0, _get.default)('name', p) === propertyName;
  });
});
var OBJECT_SEARCH_CONFIGS = (_OBJECT_SEARCH_CONFIG = {}, (0, _defineProperty2.default)(_OBJECT_SEARCH_CONFIG, _ReferenceObjectTypes.default.CONTACT, {
  url: SEARCH_API + 'contacts',
  adapter: {
    mapIds: withIdField('vid'),
    mapQuery: function mapQuery(searchQuery) {
      return searchQuery.update('sorts', function () {
        var sorts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.List)();
        return sorts.push({
          property: 'createdate',
          order: 'DESC'
        }).push({
          property: 'vid',
          order: 'DESC'
        });
      }).toJS();
    },
    mapResponse: formatResults('contacts', {
      getId: (0, _get.default)('vid'),
      getLabel: _formatContacts.formatContactName
    })
  }
}), (0, _defineProperty2.default)(_OBJECT_SEARCH_CONFIG, _ReferenceObjectTypes.default.COMPANY, {
  url: SEARCH_API + 'companies',
  adapter: {
    mapIds: withIdField('companyId'),
    mapQuery: addSortBy('createdate'),
    mapResponse: formatResults('companies', {
      getId: (0, _get.default)('company-id'),
      getLabel: (0, _getIn.default)(['properties', 'name', 'value'])
    })
  }
}), (0, _defineProperty2.default)(_OBJECT_SEARCH_CONFIG, _ReferenceObjectTypes.default.DEAL, {
  url: SEARCH_API + 'deals',
  adapter: {
    mapIds: withIdField('dealId'),
    mapQuery: addSortBy('createdate'),
    mapResponse: formatResults('deals', {
      getId: (0, _get.default)('dealId'),
      getLabel: (0, _getIn.default)(['properties', 'dealname', 'value'])
    })
  }
}), (0, _defineProperty2.default)(_OBJECT_SEARCH_CONFIG, _ReferenceObjectTypes.default.ENGAGEMENT, {
  url: SEARCH_API + 'engagements',
  adapter: {
    mapIds: withIdField('engagement.id'),
    mapQuery: addSortBy('engagement.createdAt'),
    mapResponse: formatResults('engagements', {
      getId: (0, _getIn.default)(['engagement', 'id']),
      getLabel: function getLabel(res) {
        var _res$metadata = res.metadata,
            text = _res$metadata.text,
            body = _res$metadata.body,
            subject = _res$metadata.subject,
            title = _res$metadata.title,
            type = res.engagement.type;
        var label = text || body;

        if (['EMAIL', 'INCOMING_EMAIL', 'TASK'].includes(type)) {
          label = subject;
        } else if (type === 'MEETING' && title) {
          label = title;
        }

        var normalizedLabel = label ? String(label).replace(/<\/?[^>]+(>|$)/g, '').replace(/&nbsp;/g, ' ').replace(/&#x27;/g, "'").replace(/&#8230;/, '…').replace(/&quot;/, '"') : '';
        return normalizedLabel.length > 200 ? normalizedLabel.slice(0, 200) + "\u2026" : normalizedLabel;
      }
    })
  }
}), (0, _defineProperty2.default)(_OBJECT_SEARCH_CONFIG, _ReferenceObjectTypes.default.TASK, {
  url: SEARCH_API + 'engagements',
  adapter: {
    mapIds: withIdField('engagement.id'),
    mapQuery: function mapQuery(query) {
      var taskFilter = new _immutable.Map({
        operator: 'EQ',
        property: 'engagement.type',
        value: 'TASK'
      });
      var onlyTasksFilter = (0, _updateIn.default)(['filterGroups'], function () {
        var groups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.List();
        return (0, _updateIn.default)([0, 'filters'], function () {
          var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.List();
          return filters.concat([taskFilter]);
        }, groups);
      });
      return addSortBy('engagement.createdAt', onlyTasksFilter(query));
    },
    mapResponse: formatResults('engagements', {
      getId: (0, _getIn.default)(['engagement', 'id']),
      getLabel: function getLabel(res) {
        return (0, _getIn.default)(['metadata', 'subject'], res) || (0, _getIn.default)(['metadata', 'body'], res);
      },
      getDescription: function getDescription(res) {
        // if the label is "using" the 'subject', use the body
        return (0, _hasIn.default)(['metadata', 'subject'], res) ? (0, _getIn.default)(['metadata', 'body'], res) : undefined;
      }
    })
  }
}), (0, _defineProperty2.default)(_OBJECT_SEARCH_CONFIG, _ReferenceObjectTypes.default.TICKET, {
  url: SEARCH_API + 'services/tickets?includeAllValues=true&allPropertiesFetchMode=latest_version',
  adapter: {
    mapIds: withIdField('hs_ticket_id'),
    mapQuery: addSortBy('createdate'),
    mapResponse: (0, _compose.default)(formatResults('results', {
      getId: (0, _get.default)('objectId'),
      getLabel: (0, _getIn.default)(['properties', 'subject', 'value'])
    }), subtractResultsFromOffset)
  }
}), (0, _defineProperty2.default)(_OBJECT_SEARCH_CONFIG, _ReferenceObjectTypes.default.PRODUCT, {
  url: SEARCH_API + 'products?includeAllValues=true',
  adapter: {
    mapIds: withIdField('objectId'),
    mapQuery: addSortBy('createdate'),
    mapResponse: (0, _compose.default)(formatResults('results', {
      getId: (0, _get.default)('objectId'),
      getLabel: (0, _getIn.default)(['properties', 'name', 'value'])
    }), subtractResultsFromOffset)
  }
}), (0, _defineProperty2.default)(_OBJECT_SEARCH_CONFIG, _ReferenceObjectTypes.default.PRODUCT_FOLDER, {
  url: 'folders/v1/search/products?includeAllValues=true',
  adapter: {
    mapIds: withIdField('folderId'),
    mapQuery: function mapQuery(query) {
      var FOLDER_TYPE = 2;
      var folderFilter = new _immutable.Map({
        operator: 'EQ',
        property: 'type',
        value: FOLDER_TYPE
      });
      var addProductFoldersFilter = (0, _updateIn.default)(['filterGroups'], function () {
        var groups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.List();
        return (0, _updateIn.default)([0, 'filters'], function () {
          var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _immutable.List();
          return filters.concat([folderFilter]);
        }, groups);
      });
      return addSortBy('createdate', addProductFoldersFilter(query));
    },
    mapResponse: (0, _compose.default)(formatResults('results', {
      getId: (0, _get.default)('folderId'),
      getLabel: (0, _get.default)('name')
    }), subtractResultsFromOffset)
  }
}), (0, _defineProperty2.default)(_OBJECT_SEARCH_CONFIG, _ReferenceObjectTypes.default.LINE_ITEM, {
  url: SEARCH_API + 'lineitems?includeAllValues=true',
  adapter: {
    mapIds: withIdField('objectId'),
    mapQuery: addSortBy('createdate'),
    mapResponse: (0, _compose.default)(formatResults('results', {
      getId: (0, _get.default)('objectId'),
      getLabel: (0, _getIn.default)(['properties', 'name', 'value'])
    }), subtractResultsFromOffset)
  }
}), (0, _defineProperty2.default)(_OBJECT_SEARCH_CONFIG, _ReferenceObjectTypes.default.QUOTE, {
  url: SEARCH_API + 'quotes?includeAllValues=true',
  adapter: {
    mapIds: withIdField('quoteId'),
    mapQuery: addSortBy('createdate'),
    mapResponse: (0, _compose.default)(formatResults('results', {
      getId: (0, _get.default)('quoteId'),
      getLabel: (0, _compose.default)((0, _get.default)('value'), findNamedProperty('hs_title'), (0, _get.default)('properties'))
    }), subtractResultsFromOffset)
  }
}), _OBJECT_SEARCH_CONFIG);
exports.OBJECT_SEARCH_CONFIGS = OBJECT_SEARCH_CONFIGS;

var createGetObjectsByIds = function createGetObjectsByIds(_ref) {
  var httpClient = _ref.httpClient;
  return (0, _curry.default)(function (objectType, ids) {
    var _OBJECT_SEARCH_CONFIG2 = OBJECT_SEARCH_CONFIGS[objectType],
        url = _OBJECT_SEARCH_CONFIG2.url,
        adapter = _OBJECT_SEARCH_CONFIG2.adapter;
    var query = adapter.mapIds(ids);
    return httpClient.post(url, {
      data: query
    }).then(adapter.mapResponse).then((0, _get.default)('results'));
  });
};

exports.createGetObjectsByIds = createGetObjectsByIds;
var getObjectsByIds = createGetObjectsByIds({
  httpClient: _apiClient.default
});
exports.getObjectsByIds = getObjectsByIds;

var createSearchObjects = function createSearchObjects(_ref2) {
  var httpClient = _ref2.httpClient;
  return (0, _curry.default)(function (objectType, originalQuery) {
    var _OBJECT_SEARCH_CONFIG3 = OBJECT_SEARCH_CONFIGS[objectType],
        url = _OBJECT_SEARCH_CONFIG3.url,
        adapter = _OBJECT_SEARCH_CONFIG3.adapter;
    var query = adapter.mapQuery(originalQuery);
    return httpClient.post(url, {
      data: query
    }).then(adapter.mapResponse);
  });
};

exports.createSearchObjects = createSearchObjects;
var searchObjects = createSearchObjects({
  httpClient: _apiClient.default
});
exports.searchObjects = searchObjects;